import React from "react";
import { Mail, Globe, Facebook, Youtube, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer
      id="contact"
      className="bg-burgundy-700 text-white border-t border-burgundy-600 mt-8"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <img
              src="/bcsabha-logo.png"
              alt=""
              className="h-9 sm:h-10 w-auto shrink-0 object-contain object-left drop-shadow-sm"
              width={140}
              height={36}
              decoding="async"
            />
            <span className="font-heading text-lg text-gold-100 font-semibold">
              The Bombay Catholic Sabha
            </span>
          </div>
          <p className="mt-4 text-sm text-white/85 leading-relaxed max-w-sm">
            c/o St. Michael&apos;s Church, Mahim, Mumbai 400 016. Affiliated to the
            All India Catholic Union.
          </p>
        </div>

        <div>
          <h4 className="text-xs font-semibold uppercase tracking-widest text-gold-300">
            Contact
          </h4>
          <ul className="mt-4 space-y-2 text-sm text-white/90">
            <li className="flex items-center gap-2">
              <Mail size={14} className="text-gold-400 shrink-0" aria-hidden />
              <a
                href="mailto:president@bcsabha.org"
                className="text-gold-100 hover:text-white underline-offset-2 hover:underline transition-colors"
                data-testid="footer-email-president"
              >
                president@bcsabha.org
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={14} className="text-gold-400 shrink-0" aria-hidden />
              <a
                href="mailto:info@bcsabha.org"
                className="text-gold-100 hover:text-white underline-offset-2 hover:underline transition-colors"
                data-testid="footer-email-info"
              >
                info@bcsabha.org
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={14} className="text-gold-400 shrink-0" aria-hidden />
              <a
                href="mailto:secretarygeneral@bcsabha.org"
                className="text-gold-100 hover:text-white underline-offset-2 hover:underline transition-colors"
                data-testid="footer-email-secretary"
              >
                secretarygeneral@bcsabha.org
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Phone size={14} className="text-gold-400 shrink-0" aria-hidden />
              <a
                href="tel:+919820728277"
                className="text-gold-100 hover:text-white underline-offset-2 hover:underline transition-colors"
                data-testid="footer-phone"
              >
                +91 98207 28277
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Globe size={14} className="text-gold-400 shrink-0" aria-hidden />
              <a
                href="https://www.bcsabha.org"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gold-100 hover:text-white underline-offset-2 hover:underline transition-colors"
                data-testid="footer-website"
              >
                www.bcsabha.org
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Facebook size={14} className="text-gold-400 shrink-0" aria-hidden />
              <a
                href="https://www.facebook.com/thebombaycatholicsabha/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gold-100 hover:text-white underline-offset-2 hover:underline transition-colors"
                data-testid="footer-facebook"
              >
                The Bombay Catholic Sabha
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Youtube size={14} className="text-gold-400 shrink-0" aria-hidden />
              <a
                href="https://www.youtube.com/@BCSabha"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gold-100 hover:text-white underline-offset-2 hover:underline transition-colors"
                data-testid="footer-youtube"
              >
                @BCSabha
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-semibold uppercase tracking-widest text-gold-300">
            Souvenir
          </h4>
          <p className="mt-4 text-sm text-white/85 leading-relaxed">
            Sabha Day 2026 Souvenir — a keepsake celebrating sponsors, parishes and
            community well-wishers.
          </p>
        </div>
      </div>
      <div className="border-t border-burgundy-600/70 bg-burgundy-800/90">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row flex-wrap items-center justify-between gap-3 sm:gap-4">
          <span className="text-xs text-white/65 text-center sm:text-left">
            © {new Date().getFullYear()} The Bombay Catholic Sabha. All rights reserved.
          </span>
          <div className="text-center sm:text-right">
            <p className="mt-1 text-[11px] text-white/50">
              Site developed by{" "}
              <span className="text-white/70">Peep Around Private Limited</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
